import React, {createContext, useState, useEffect} from 'react';

import useKanban from './useKanban';

const KanbanContext = createContext();

function KanbanProvider({children}) {
    const {dataKanban, utilizadores, dataFiltrada, tags, setDataFiltrada, move, GetData, etapas, negocios} = useKanban();

    return (
        <KanbanContext.Provider
            value={{
                dataKanban,
                utilizadores,
                dataFiltrada,
                setDataFiltrada,
                tags,
                move,
                GetData,
                etapas,
                negocios,
            }}>
            {children}
        </KanbanContext.Provider>
    );
}

export {KanbanContext, KanbanProvider};
